import React from 'react';
import { LinearProgress, Stack, Typography } from '@mui/material';
import LocalGroceryStoreRoundedIcon from '@mui/icons-material/LocalGroceryStoreRounded';
import { toNumber, formatInt } from '../../utils/format';
import WidgetShell from './WidgetShell';

function BagTasteWidget({ stats }) {
  const presetUsageEntries = Object.entries(stats?.runs?.presetUsage || {});
  const startedRuns = toNumber(stats?.runs?.started);

  return (
    <WidgetShell
      icon={<LocalGroceryStoreRoundedIcon color="primary" fontSize="small" />}
      title="Your Bag Taste"
    >
      {presetUsageEntries.length ? (
        <Stack spacing={1.1}>
          {presetUsageEntries.map(([preset, count]) => {
            const ratio = startedRuns > 0 ? (toNumber(count) / startedRuns) * 100 : 0;
            return (
              <Stack key={preset} spacing={0.4}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Typography sx={{ textTransform: 'capitalize', fontWeight: 700 }}>
                    {preset}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {formatInt(count)} runs
                  </Typography>
                </Stack>
                <LinearProgress
                  variant="determinate"
                  value={Math.max(0, Math.min(100, ratio))}
                  sx={{ height: 8, borderRadius: 6 }}
                />
              </Stack>
            );
          })}
        </Stack>
      ) : (
        <Typography color="text.secondary">No preset usage yet.</Typography>
      )}
    </WidgetShell>
  );
}

export default BagTasteWidget;
